import { render, staticRenderFns } from "./SearchSynonyms.vue?vue&type=template&id=799c786c&scoped=true&"
import script from "./SearchSynonyms.vue?vue&type=script&lang=js&"
export * from "./SearchSynonyms.vue?vue&type=script&lang=js&"
import style0 from "./SearchSynonyms.vue?vue&type=style&index=0&id=799c786c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799c786c",
  null
  
)

export default component.exports